import { useState } from "react";
import { BrandLogo } from "./BrandLogo";

type PublicSiteHeaderProps = {
  active?: "home" | "candidate-guide";
};

const links: readonly { href: string; label: string; active?: PublicSiteHeaderProps["active"] }[] = [
  { href: "/#hero", label: "首页", active: "home" },
  { href: "/#ranks", label: "考核招募" },
  { href: "/#examiners", label: "考官直播" },
  { href: "/candidate-guide", label: "考核须知", active: "candidate-guide" },
  { href: "/examiner/login", label: "考官入口" }
];

export function PublicSiteHeader({ active }: PublicSiteHeaderProps) {
  const [open, setOpen] = useState(false);

  return (
    <header className="site-header">
      <BrandLogo horizontal />
      <nav className={open ? "is-open" : ""} aria-label="主导航">
        {links.map((link) => {
          const isActive = Boolean(link.active && link.active === active);
          return (
            <a
              className={isActive ? "is-active" : undefined}
              href={link.href}
              aria-current={isActive ? "page" : undefined}
              onClick={() => setOpen(false)}
              key={link.href}
            >
              {link.label}
            </a>
          );
        })}
      </nav>
      <button
        className="menu-toggle"
        type="button"
        aria-label={open ? "关闭导航" : "打开导航"}
        aria-expanded={open}
        onClick={() => setOpen(!open)}
      >
        <span />
        <span />
      </button>
    </header>
  );
}
